import React from 'react'

const status_badge = ({status}) => {
  const getColor = () => {
    if(status === "Available")return "#D0F0C0"
    if(status === "Busy")return "#FDA172"
    return "white"
  }
  return (
    <div class="d-flex text-center align-items-center justify-content-center" style={{backgroundColor:getColor(), padding:"2px 10px ", borderRadius:'20px', height:'15px', fontSize:"10px"}}>{status}</div>
  )
}

export default status_badge